<!-- GBWhatsApp 专题页 | 路由：/gbwhatsapp-apk/ -->
<template>
  <div class="page-wrap">
    <FmNavBar />
    <div class="container">
      <header class="hero">
        <h1>GBWhatsApp APK Download Guide (2026): Features, Risks &amp; Safe Install</h1>
        <p>
          GBWhatsApp is one of the longest-running WhatsApp modifications for Android. This guide explains what it does,
          what third-party download pages commonly report in early 2026, how it differs from official WhatsApp, and how
          to reduce ban and malware risk if you choose to use it.
        </p>
        <a href="javascript:void(0)" class="btn" @click.prevent="downloadGbApk">Download GB WhatsApp</a>
      </header>

      <section class="section">
        <h2>Quick facts (check your APK source)</h2>
        <p>
          Because GBWhatsApp is not distributed through Google Play, <strong>version numbers and file sizes vary by mirror</strong>.
          Community download pages in early 2026 often list stable builds around <strong>v18.70–v18.80</strong>, with APK sizes
          commonly quoted between roughly <strong>78MB and 100MB</strong> and Android support starting around <strong>Android 5.0+</strong>.
          Always verify the publisher, checksum (if provided), and update date before installing.
        </p>
        <table class="facts-table">
          <tbody>
            <tr><th scope="row">Platform</th><td>Android (APK sideload)</td></tr>
            <tr><th scope="row">Official store</th><td>No (third-party APK only)</td></tr>
            <tr><th scope="row">Typical feature focus</th><td>Theming, privacy toggles, larger media limits</td></tr>
            <tr><th scope="row">Account risk</th><td>Real ban risk; not eliminable by “anti-ban” marketing</td></tr>
          </tbody>
        </table>
      </section>

      <section class="section">
        <h2>What is GBWhatsApp?</h2>
        <p>
          GBWhatsApp is an unofficial, modified build of WhatsApp Messenger. Independent developers repackage WhatsApp’s
          Android client and add features Meta does not ship in the official app: deeper UI customization, extended privacy
          controls, optional utilities (such as message scheduling and auto-replies on many builds), and higher media limits
          than the stock client enforces.
        </p>
        <p>
          It is <strong>not affiliated with Meta</strong>, does not receive Play Protect distribution benefits, and can violate
          WhatsApp’s Terms of Service. That legal and policy reality matters more than any feature list: your account can be
          restricted if WhatsApp detects unsupported clients or abusive behavior patterns.
        </p>
        <h3>Who usually installs GBWhatsApp?</h3>
        <p>
          Typical users include people who want theme packs, icon packs, bubble styles, and granular read-receipt controls;
          creators who dislike aggressive media compression; and small teams that want lightweight automation (auto-reply)
          without migrating to WhatsApp Business API. None of these use cases remove ban risk—they only change the
          trade-offs you accept.
        </p>
      </section>

      <section class="section">
        <h2>What third-party sites highlight in 2026 (feature overview)</h2>
        <p>
          The following capabilities appear frequently across third-party GBWhatsApp landing pages in 2026. Treat them as
          <strong>common marketing claims</strong>, not guarantees, because forks differ and features change per developer branch.
        </p>
        <h3>Privacy and “read state” controls</h3>
        <ul>
          <li>Hide online status, typing indicators, and recording indicators (often with per-contact granularity on newer builds).</li>
          <li>Freeze or spoof “last seen” behavior compared to stock WhatsApp.</li>
          <li>Anti-delete / anti-revoke style message retention so deleted messages may remain visible locally.</li>
        </ul>
        <h3>Customization</h3>
        <ul>
          <li>Large theme libraries, custom fonts, chat bubble shapes, launcher icon variants, and home screen styling.</li>
          <li>Per-chat wallpaper and color tweaks beyond official limits.</li>
        </ul>
        <h3>Media and productivity utilities</h3>
        <ul>
          <li>Higher caps for batch images/videos and larger single-file sends than stock WhatsApp (exact caps vary by build).</li>
          <li>Status downloaders and profile media tools on many forks.</li>
          <li>Message scheduler and auto-reply modules on popular community builds.</li>
        </ul>
      </section>

      <section class="section">
        <h2>GB WhatsApp Bans, “anti-ban,” and what independent reporting says</h2>
        <p>
          Multiple independent explainers in 2026 repeat the same point: <strong>WhatsApp actively enforces its client ecosystem</strong>.
          Unofficial mods can trigger warnings, temporary suspensions, or permanent loss of access, especially when combined
          with spam-like behavior, rapid group joins, broadcast abuse, or very outdated packages after WhatsApp protocol
          updates.
        </p>
        <p>
          Marketing phrases like “anti-ban” describe <strong>risk reduction tactics inside the mod</strong>, not immunity. The safest
          policy for a primary phone number is still the official WhatsApp client from Google Play. If you experiment with
          GBWhatsApp, use a secondary number, keep backups, and plan a fallback channel.
        </p>
        <h3>Lower-risk usage habits (practical)</h3>
        <ol>
          <li>Install only from a source you trust; avoid repacked APKs with extra permissions.</li>
          <li>Update quickly after major WhatsApp base updates; stale mods are easier to fingerprint.</li>
          <li>Avoid bulk messaging to unsaved contacts and avoid aggressive automation.</li>
          <li>Do not stack multiple mods for the same number on one device.</li>
        </ol>
      </section>

      <section class="section">
        <h2>GB WhatsApp Download and install (Android checklist)</h2>
        <p>
          These steps reflect the standard sideload pattern for WhatsApp mods. Your OEM menus may differ slightly
          (especially Android 13+ per-app install permissions).
        </p>
        <ol>
          <li><strong>Back up official WhatsApp</strong> (Settings → Chats → Chat backup) if you are migrating the same number.</li>
          <li><strong>Download the APK</strong> from a verified distributor page; compare file size and version with the site’s table.</li>
          <li><strong>Enable install from trusted sources</strong> (Settings → Apps → Special access → Install unknown apps).</li>
          <li><strong>Install</strong>, launch, verify SMS/voice OTP, then restore backup when prompted.</li>
          <li><strong>Turn on Google Play Protect scanning</strong> after install as an extra hygiene step (it may flag mods—read why).</li>
        </ol>
        <h3>Update workflow</h3>
        <p>
          Expect <strong>manual APK updates</strong>. Many users keep the previous APK installer file, back up chats, then install the new
          APK over the existing app (non-destructive when the package name matches). If update fails, uninstall only after a
          fresh backup to local storage.
        </p>
      </section>

      <section class="section">
        <h2>GBWhatsApp vs official WhatsApp (honest comparison)</h2>
        <table class="facts-table">
          <thead>
            <tr><th>Topic</th><th>GBWhatsApp</th><th>Official WhatsApp</th></tr>
          </thead>
          <tbody>
            <tr><td>Distribution</td><td>APK mirrors</td><td>Google Play / App Store</td></tr>
            <tr><td>Customization depth</td><td>Very high</td><td>Limited</td></tr>
            <tr><td>Ban risk</td><td>Present</td><td>Minimal for normal use</td></tr>
            <tr><td>Support channel</td><td>Community / none</td><td>Meta support paths</td></tr>
            <tr><td>Update cadence</td><td>Manual</td><td>Automatic security patches</td></tr>
          </tbody>
        </table>
      </section>

      <section class="section">
        <h2>GBWhatsApp vs FM WhatsApp</h2>
        <p>
          GBWhatsApp is historically the “theme king” fork: enormous style libraries and deep UI tweaks. FM WhatsApp (on our
          site hub) is positioned as a streamlined alternative with strong privacy tooling and a consistent update narrative
          for users who do not want to chase every fork variant. Neither mod removes Meta policy risk—choose based on whether
          you prioritize maximum theming (GB) or a more guided MOD workflow (FM).
        </p>
      </section>

      <section class="section">
        <h2>Common issues and fixes</h2>
        <h3>OTP not arriving</h3>
        <p>Confirm SMS/call permissions, disable aggressive battery savers for the app, and switch from Wi‑Fi to mobile data.</p>
        <h3>Crash on launch after an update</h3>
        <p>Clear cache, reinstall the latest APK build, and ensure you did not mix package variants from different authors.</p>
        <h3>Media stuck sending</h3>
        <p>Free storage, verify file cap for your build, and re-check background data permissions.</p>
      </section>

      <section class="section">
        <h2>FAQ</h2>
        <h3>Is GBWhatsApp legal?</h3>
        <p>
          Possessing an APK is generally not the issue; violating WhatsApp’s terms or tampering with client integrity can be.
          This page is informational—not legal advice.
        </p>
        <h3>Can “anti-ban” be 100%?</h3>
        <p>No. Treat it as mitigation, not a promise.</p>
        <h3>Should businesses use GBWhatsApp?</h3>
        <p>
          For regulated workflows, prefer the official WhatsApp Business Platform/API. Mods lack vendor SLAs and audit trails.
        </p>
      </section>

      <section class="section">
        <h2>Related pages on this site</h2>
        <p>
          <a href="/" @click.prevent="goRoute('/')">FM WhatsApp home</a>
          ·
          <a href="/download/" @click.prevent="goRoute('/download/')">Download hub</a>
          ·
          <a href="/yowhatsapp-apk/" @click.prevent="goRoute('/yowhatsapp-apk/')">YoWhatsApp</a>
          ·
          <a href="/ogwhatsapp-apk/" @click.prevent="goRoute('/ogwhatsapp-apk/')">OGWhatsApp</a>
          ·
          <a href="/jtwhatsapp-apk/" @click.prevent="goRoute('/jtwhatsapp-apk/')">JTWhatsApp</a>
          ·
          <a href="/mbwhatsapp-apk/" @click.prevent="goRoute('/mbwhatsapp-apk/')">MBWhatsApp</a>
          ·
          <a href="/blue-whatsapp-plus-apk/" @click.prevent="goRoute('/blue-whatsapp-plus-apk/')">Blue WhatsApp Plus</a>
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import FmNavBar from '@/components/FmNavBar.vue'

export default {
  name: 'GBWhatsApp',
  components: { FmNavBar },
  methods: {
    goRoute(path) {
      this.$router.push(path).catch(() => {})
    },
    /** 请求 H5 /apk 接口取 GB 直链并触发下载（与 privacy 页 getOfficalApk 一致） */
    downloadGbApk() {
      const fallback =
        process.env.VUE_APP_GBLINK || process.env.VUE_APP_DEFAULT_APK || ''
      this.$server
        .getOfficalApk({
          domain: 'gbwhatsapp.chat',
          appName: 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          const apk =
            res && res.code === 200 && res.data && res.data.apk
              ? res.data.apk
              : fallback
          if (apk) this.$global.download(apk)
        })
        .catch(() => {
          if (fallback) this.$global.download(fallback)
        })
    },
  },
}
</script>

<style scoped>
.page-wrap {
  background: #f5f5f5;
  min-height: 100vh;
}
.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px;
}
.hero {
  background: #075e54;
  color: #fff;
  padding: 28px 20px;
  border-radius: 12px;
  margin-bottom: 24px;
}
.hero h1 {
  margin: 0 0 12px;
  font-size: 32px;
  line-height: 1.25;
}
.hero p {
  margin: 0 0 16px;
  font-size: 17px;
  line-height: 1.7;
  max-width: 920px;
}
.btn {
  background: #25d366;
  color: #fff;
  text-decoration: none;
  padding: 12px 22px;
  border-radius: 8px;
  font-weight: 700;
  display: inline-block;
}
.btn:hover {
  background: #1ea854;
}
.section {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.section h2 {
  color: #075e54;
  margin: 0 0 12px;
  border-left: 4px solid #25d366;
  padding-left: 10px;
  font-size: 24px;
}
.section h3 {
  color: #008069;
  margin: 18px 0 8px;
  font-size: 18px;
}
.section p {
  margin: 0 0 12px;
  font-size: 16px;
  line-height: 1.75;
  color: #222;
}
.section ul,
.section ol {
  margin: 0 0 12px;
  padding-left: 22px;
}
.section li {
  margin-bottom: 9px;
  line-height: 1.65;
}
.facts-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
}
.facts-table th,
.facts-table td {
  border: 1px solid #d9e3df;
  padding: 10px 12px;
  text-align: left;
  vertical-align: top;
  font-size: 15px;
}
.facts-table thead th {
  background: #0a6f63;
  color: #fff;
}
::v-deep(.section a) {
  color: #008069;
  font-weight: 600;
}
@media (max-width: 768px) {
  .hero h1 {
    font-size: 25px;
  }
  .section {
    padding: 16px;
  }
}
</style>
